import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdverticalService } from 'src/app/services/adverticalService/advertical.service';
import { AssetsService } from 'src/app/services/assetsService/assets.service';
import { ListService } from 'src/app/services/listService/list-service.service';
import { PlayMediaService } from 'src/app/services/playMediaService/play-media.service';
import { ProductsService } from 'src/app/services/productsService/products.service';
import { RateService } from 'src/app/services/rateService/rate-service.service';

import { Asset } from 'src/app/interfaces/asset';
import { LanguageService } from 'src/app/services/languageService/language.service';
import { DialogService } from 'src/app/services/dialogService/dialog-service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.less']
})
export class DetailsComponent implements OnInit {
  details: Asset;
  cast;
  ribbon;
  buttons;
  seasons;
  bookSeason = 0;
  lang;
  constructor(private activatedRoute: ActivatedRoute, private assesService: AssetsService, private listService: ListService, private rateService: RateService, private playMediaService: PlayMediaService, private productsService: ProductsService, private adverticalService: AdverticalService, private languageService: LanguageService, public dialogService: DialogService) {
    this.lang = this.languageService.getLanguage();
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this.init();
    });
  }

  // Initialize Component
  private init() {
    this.resetComponent();
    this.getData(this.activatedRoute.snapshot.params['id'].split('&')[0]);
  }

  // Reset all the variables
  private resetComponent() {
    this.details = null;
    this.cast = {
      directors: new Array(),
      actors: new Array()
    };
    this.ribbon = null;
    this.seasons = null;
  }

  // Get Data from server
  private getData(assetId) {
    this.assesService.getAssetDetails({
      assetId: assetId
    }).then((resp: any) => {
      this.details = resp.data.asset;

      this.cast.directors = this.details?.cast?.filter(obj => obj.type == 1).slice(0, 3);
      this.cast.actors = this.details?.cast?.filter(obj => obj.type == 0).slice(0, 3);

      this.setButtons(this.details);
      this.setExtraAssets();
      this.setVideoListener();

      // Get Advertisement 
      this.adverticalService.getBanner("Details_Banner", "DETAILS_BANNER", false);
    });
  }

  // Setting Recommendation or seasons
  private setExtraAssets() {
    // If it is a Movie display recommendations
    if (this.details.type == 0 && this.details?.categoryIds.length) {
      this.assesService.getSimilarAssets({ assetId: this.details.id, categoryId: this.details.categoryIds[0] }).then((similar: any) => {
        similar.data.title = "gen_program_similar_recommendations";
        similar.data.style = environment.features.posterType == "h" ? "B" : "C";
        this.ribbon = similar.data;
      });
    } else if (this.details.type == 1) {
      // if it is a serie
      this.setSeasons(null);
    }
  }

  // Listener when the user closes the player
  private setVideoListener() {
    this.playMediaService.getPlayerStatus.subscribe((resp: any) => {
      this.details.bookmarkInfo.seek = resp.seek;
      this.details.bookmarkInfo.percentage = resp.percentage;
      if (resp.episodeNumber) {
        this.details.bookmarkInfo.episodeNumber = resp.episodeNumber;
        this.details.bookmarkInfo.seasonNumber = resp.seasonNumber;
        this.setSeasons(this.details.bookmarkInfo);
      }
      this.setButtons(this.details);
    });
  }

  // Setup Seasons
  private setSeasons(bookmark) {
    this.seasons = this.getEpisodesButtons(bookmark);
    this.findBookmarkedSeason();
  }

  /** Map seasons episodes in order to set bookmark buttons  */
  private getEpisodesButtons(bookmark) {
    this.details.seasons.forEach(season => {
      season.episodes.forEach(episode => {
        // Update bookmark
        if (bookmark && bookmark.episodeNumber == episode.episodeNumber && bookmark.seasonNumber == episode.seasonNumber) {
          episode.bookmarkInfo = bookmark;
        }
        episode.button = this.setUpButton(episode);
      });
    });
    return this.details.seasons;
  }

  /** Find in which season asset has bookmark  */
  private findBookmarkedSeason(): void {
    this.seasons.find((obj, pos) => {
      if (obj.seasonNumber == this.details.bookmarkInfo.seasonNumber) {
        this.bookSeason = pos;
      }
      return obj.seasonNumber == this.details.bookmarkInfo.seasonNumber;
    });
  }

  // Create dynamic list with buttons
  private setButtons(details) {
    // Play || Continue || Watch Again || Subscribe
    this.buttons = [this.setUpButton(details)];

    // Trailer
    if (this.details.trailers) {
      this.buttons.push({
        id: "trailer",
        icon: "fa fa-play",
        title: "gen_trailer"
      })
    }

    // List
    this.buttons.push(this.listService.setUpButton(this.details.inList));

    // Rate
    if (details.isSubscribed) {
      this.buttons.push({
        id: "rate",
        icon: "fa fa-star",
        title: "gen_rate"
      });
    }

    // More
    this.buttons.push({
      id: "more",
      icon: "fa fa-info-circle",
      title: "gen_more"
    });
  }

  // Return the proper button play, continue watching or subscribe
  private setUpButton(details) {
    return {
      id: this.getButtonId(details),
      icon: details.isSubscribed ? "fa fa-play" : "fa fa-shopping-cart",
      title: this.getButtonTitle(details),
      percentage: details.bookmarkInfo.percentage >= 0 ? details.bookmarkInfo.percentage : 0
    }
  }

  /** Return the proper button id  */
  private getButtonId(details) {
    if (details.isSubscribed) {
      return details.bookmarkInfo.percentage >= 0 ? "continue" : "play";
    }
    return "subscribe";
  }

  /** Return the proper button title  */
  private getButtonTitle(details) {
    if (details.isSubscribed) {
      return details.bookmarkInfo.percentage >= 0 ? (details.bookmarkInfo.percentage <= 98 ? "gen_bookmarks" : "gen_watch_again") : "gen_play";
    }
    return "gen_subscribe";
  }

  // Click Actions for buttons
  public doAction(button, pos, episode) {
    switch (button.id) {
      case "subscribe":
        this.subscribeAsset();
        break;
      case "continue":
      case "play":
        this.playAsset(episode);
        break;
      case "myList":
        this.toggleList(pos);
        break;
      case "trailer":
        this.playMediaService.playTrailer(this.details, this.details.trailers[0]);
        break;
      case "rate":
        this.rateAsset();
        break;
      case "more":
        this.dialogService.openMoreDialog(this.details);
        break;
    }
  }

  /** Subscribe to an asset */
  private subscribeAsset(): void {
    this.productsService.getProductsAsset(this.details.id).then((resp: any) => {
      if (resp) {
        this.init();
      }
    });
  }

  /** Play an asset  */
  private playAsset(episode): void {
    this.playMediaService.play(this.details, episode);
  }

  /** Toggle my list button  
   * @param {Number} pos position of the button
  */
  private toggleList(pos): void {
    this.listService.toggleList(this.details).then(result => {
      this.details.inList = !this.details.inList;
      this.buttons[pos] = result;
    });
  }

  /** Rate an asset  */
  private rateAsset(): void {
    this.dialogService.openRateDialog(this.details).subscribe(result => {
      this.submitRate(result);
    });
  }

  /** Submit Rate to the service
   * @param {Number} rate (1,2,3,4,5)
  */
  private submitRate(rate): void {
    if (this.details.isSubscribed && rate) {
      this.rateService.rate({
        asset: this.details,
        rating: rate
      }).then((resp: any) => {
        this.details.myRating = rate;
      });
    }
  }
}